function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 23,
  fill: "#FFF",
  stroke: "#102E8E",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M12 12h24v24H12z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M31 18.41L29.59 17 24 22.59 18.41 17 17 18.41 22.59 24 17 29.59 18.41 31 24 25.41 29.59 31 31 29.59 25.41 24z"
}));

var SvgIcCloseLargeOutline = function SvgIcCloseLargeOutline(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjMiIGZpbGw9IiNGRkYiIHN0cm9rZT0iIzEwMkU4RSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgICAgPHBhdGggZD0iTTEyIDEyaDI0djI0SDEyeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGQ9Ik0zMSAxOC40MUwyOS41OSAxNyAyNCAyMi41OSAxOC40MSAxNyAxNyAxOC40MSAyMi41OSAyNCAxNyAyOS41OSAxOC40MSAzMSAyNCAyNS40MSAyOS41OSAzMSAzMSAyOS41OSAyNS40MSAyNHoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIcCloseLargeOutline as ReactComponent };